// @gen this file is generated from `bindings/ocaml/o1js_constants.ml` - don't edit it directly
export {
  mocks,
  poseidonParamsKimchiFp,
  poseidonParamsLegacyFp,
  prefixHashes,
  prefixHashesLegacy,
  prefixes,
  protocolVersions,
  versionBytes,
};

let prefixes = {
  event: 'MinaZkappEvent******',
  events: 'MinaZkappEvents*****',
  sequenceEvents: 'MinaZkappSeqEvents**',
  zkappBodyMainnet: 'MainnetZkappBody****',
  zkappBodyTestnet: 'TestnetZkappBody****',
  accountUpdateCons: 'MinaAcctUpdateCons**',
  accountUpdateNode: 'MinaAcctUpdateNode**',
  account: 'MinaAccount*********',
  zkappAccount: 'MinaZkappAccount****',
  zkappMemo: 'MinaZkappMemo*******',
  signatureMainnet: 'MinaSignatureMainnet',
  signatureTestnet: 'CodaSignature*******',
  zkappUri: 'MinaZkappUri********',
  deriveTokenId: 'MinaDeriveTokenId***',
  sideLoadedVK: 'MinaSideLoadedVk****',
  merkleTree: [
    'MinaMklTree000******',
    'MinaMklTree001******',
    'MinaMklTree002******',
    'MinaMklTree003******',
    'MinaMklTree004******',
    'MinaMklTree005******',
    'MinaMklTree006******',
    'MinaMklTree007******',
    'MinaMklTree008******',
    'MinaMklTree009******',
    'MinaMklTree010******',
    'MinaMklTree011******',
    'MinaMklTree012******',
    'MinaMklTree013******',
    'MinaMklTree014******',
    'MinaMklTree015******',
    'MinaMklTree016******',
    'MinaMklTree017******',
    'MinaMklTree018******',
    'MinaMklTree019******',
    'MinaMklTree020******',
    'MinaMklTree021******',
    'MinaMklTree022******',
    'MinaMklTree023******',
    'MinaMklTree024******',
    'MinaMklTree025******',
    'MinaMklTree026******',
    'MinaMklTree027******',
    'MinaMklTree028******',
    'MinaMklTree029******',
    'MinaMklTree030******',
    'MinaMklTree031******',
    'MinaMklTree032******',
    'MinaMklTree033******',
    'MinaMklTree034******',
  ],
};
let prefixHashes = {
  'CodaReceiptUC*******': [
    '2930292359494829300271368860633580634815819151887078160583250237349129726103',
    '15303314845540397914948764201521841781296890621466368017042313538410516382474',
    '8520568699315305732843613022173524514377597839978192694761879649747314556194',
  ],
  'CodaReceiptZkapp****': [
    '10173709693039436418323173817852473796760618468635274081106091878172355412495',
    '8139892805413950771311540201181177376747817902069998595519899391903936767134',
    '13514876620613630149351219463845257700223634963001020028151406467995275024594',
  ],
  'Coinbase************': [
    '16825847102297458526359719396083434368788313103713242309655412848174457920423',
    '21732702256017917816272795771734458959259892802453584375610183841451053027064',
    '20669950187190141732603807229833302926112666951294341954340514712643194206110',
  ],
  'PendingCoinbases****': [
    '16730315671906078134534118281698719603694322959719576832314142406897554025946',
    '25168172107432119701402092802564698772609386283424806773354665411015030859956',
    '20203823516569384790863281992678977204769111540506990077513414850340465376267',
  ],
  'CoinbaseStackData***': [
    '23795978781100345043289806728009175185120094645976380845310050347461663815988',
    '22848259504294538625391413055517172710405127059374914145881816600826824598643',
    '8292468073974572410325570929211069869427868613763277519881895337391418731450',
  ],
  CoinbaseStackStaHash: [
    '335203117218289187585524630708440909952721586869179589604793956147132569543',
    '27066428515933869709871979311099618239824992817474733219473754649926311088531',
    '21249847167218596842529246266817628519376871370045151307329588726090940941283',
  ],
  'CoinbaseStack*******': [
    '10365018507282248303752506973112854406071106890516858854157506926717812932750',
    '19289691782405010481159082968251292806607879795611766141901748131065655579721',
    '8987039650233860747996941600635099179155585390854763935988086491644855810711',
  ],
  'MinaCheckpoints*****': [
    '15873130589302091361863210575263731242593763730169570459166821652327279429416',
    '27741778946681194402252199348726997679847260280438775383573755416459042152245',
    '7598438620402360345138640933713109733801127070065255775405685972203496634081',
  ],
  'MinaMergeSnark******': [
    '5465206932306554741198859294482250047374987110116571903153751264716396266207',
    '28325265961862852836567844362114881306407823522046946129773393861560948847052',
    '20049678444717746759028157787181298288785775657186008836042341914370292827996',
  ],
  'MinaBaseSnark*******': [
    '15502310217431654911062859746106286672455410530942120153504175184205809302248',
    '3469045624943527165009161295743804688154058669917024998601801713171804105078',
    '16667965011323249535055526937874001443515091810412343722400939445165393857780',
  ],
  'MinaProtoState******': [
    '5218970939948495870036503265499543025475317910763049867270287867667146978870',
    '7663210626148314949787033187186036425676070286961909238040356477815169631084',
    '19859188289320816036969227839574854326171440874550138016648548415357198703337',
  ],
  'MinaProtoStateBody**': [
    '3548547909990922956559515810876765435326873020883079662683136168632773655275',
    '134182536761489093478066959027928272525080293912190881939140820794450385287',
    '18910449726094816833941350890285540874861148441082116020102338532207375519343',
  ],
  'MinaVrfMessage******': [
    '24101363367502572671624471609928959797353672294440762288404204895418767914646',
    '5171820881164007689309616183632792746219180909518238150637460314245246143263',
    '10979796915023089328772347959806029121878467684484216605075459818053899045444',
  ],
  MinaSignatureMainnet: [
    '28597293842583882050529337819282358444728515448690248936274177901465134844489',
    '13029865398778858891320837481651890827971447635226272051516204921834229015884',
    '2324960771278703080070347074343683653953770644553957353754880132143131569147',
  ],
  'CodaSignature*******': [
    '6547874669265470003564181123405173756111990160585052594027544303901364349512',
    '22191763046611062479784309793717481299019591714391827084400612211604078633201',
    '15360317550574394687602808211901764964514686767298144053612144955373862517277',
  ],
  'MinaVrfOutput*******': [
    '2251514781415689779315070305878469259850299612928948069881728941286436529416',
    '28445424317765931437563566658155841532256907311948842353165636913979445243675',
    '1697103740469522139030362533818365124680980524626250761960654638291888644330',
  ],
  'MinaVrfEvaluation***': [
    '28080055385183205248434069314913715411795750554846638282391132356635075327118',
    '25018718747831549163470950235902703474807728450690404911050923194299837536932',
    '3256623657773355300700179149632147114566124258546613752475489953689825740823',
  ],
  'MinaEpochSeed*******': [
    '7920024158807749362970659876749181530334941449960381128739613586571256360405',
    '13756862713999441076472977832321298402266591073703520273734381195492800342833',
    '16931743843465107540110860558687538825985475311420101960428698400767332393906',
  ],
  'MinaTransitionSnark*': [
    '11049595972041980914958840531625028328602860712038036656362464370121336040984',
    '24369517789348117364784880800333031735213111703459853079908318927717982912175',
    '996573540734206293061884582007205418029995442386259428924494388795357965385',
  ],
  'MinaAccount*********': [
    '21547009634669789644192675386133007766042650219024716227935570378579547706642',
    '3869977418072959680344087467966431440327948593054069717779845397512987438978',
    '17591003611016737523041467644989399067682599282318802410210271366172380277153',
  ],
  'MinaZkappAccount****': [
    '11742420651603425685690711434636216727968618158667382343736587130720645535016',
    '20917169788479399921968659996772666237321879817943938162255353371266230737562',
    '20221577186851444354528754069740362935513598751580381763045954351047955571417',
  ],
  'MinaSideLoadedVk****': [
    '27153629295534844750482612843518005572402188741101822965689207110291504095805',
    '11073437601016088346212553894160581939150688827288603152461976873708720172824',
    '9169013693168830396847022454402673046094697740892173219744332585469764409612',
  ],
  'MinaZkappPayload****': [
    '15735138827391397348912010094577234813869450438840158969759900004702547928125',
    '25095612872941242247876048162039143509752212627701285511972307921367391645919',
    '7245494597725009330136300549232949784423520250577599502394596645257342395146',
  ],
  'MainnetZkappBody****': [
    '10214915150831852734808709087755641273868350720962413399868532305813227181967',
    '19231103515031626108540280352804904215178644233964839448405623573586547300771',
    '3202185325412846279878024015439663797323768206239602518916650099275135615824',
  ],
  'TestnetZkappBody****': [
    '20037733640875789833090442509053816933966165101372309054048970230906793051053',
    '1106678471497583468621635190733109842219273971961053291385773425960251864224',
    '25565387364959491931899708566015584890804577695743228799735258954982776499278',
  ],
  'MinaZkappPred*******': [
    '1288860557840839698672685006364179285130411098848600694737282320588924548492',
    '24648295833336558525603848295184424886548932461541421142783307792871113347031',
    '1330615836835056811243082335077124866238751435915242573993316916713469087050',
  ],
  'MinaZkappPredAcct***': [
    '16247099195538206941970428186933809576049890124762896310373916059400681012938',
    '15171999803179862436296250357712424012107969488385552487664863256867849154640',
    '4695118160519310765712802705640939163487421977728313886668234870398464448283',
  ],
  'MinaZkappPredPS*****': [
    '28115844434401213157045670864292277190427496512916771660477513364996586226191',
    '17764239860871865704512758086410304367016330694375482081848267812860896213477',
    '2608563583120825722034995217249250504732387097295075568312443453761249924462',
  ],
  'MinaAcctUpdAcctPred*': [
    '11173347481325879282537380504137543614432174467122278589147153842480174214350',
    '22433785030516935555884954114999194863743668497200511950547006360846720681436',
    '4261224905860522407514587942832658209487173552801239748203234114069543449134',
  ],
  'MinaAcctUpdateCons**': [
    '7974184247425786365466969127827083941281743695327546149120833518746435921046',
    '1079147682067570431747049877519099849334832444581201545961023544596733431550',
    '9670106619202136718451303928765479503313491401619698334696903962327538130992',
  ],
  'MinaAcctUpdateNode**': [
    '15921812961830232432174711488904180713275251781093575291539345321597011303739',
    '5852213322332241594845871336918115662219071361771346507406094569679662937607',
    '21122827334147180286039671993443893600964526985496742826857975683524856341379',
  ],
  'MinaAcctUpdStckFrm**': [
    '1223279431820750727612295994589444883292600761079562536688416996919972234987',
    '1873141333924103856860857609363983758885824745969813373245393521390926426683',
    '3550105212452130151915860825756512345408015936295894584118372238840612023788',
  ],
  MinaActUpStckFrmCons: [
    '2363089775097766730570162674460603870980415123701610894146069429352874281636',
    '8717086429614898734892919627864489205116600585932141922995487227707208282057',
    '14660270392332597302006144557344641683528071714290878702086758222477469533211',
  ],
  'MinaZkappUri********': [
    '534822897390732927195976832726937157108052596941484097303405936433225931144',
    '21308674973525253012607500915181592359821899373849668837401701284134790635210',
    '19235616568963430752220890547731083898076295596325584947617173371158207986317',
  ],
  'MinaZkappEvent******': [
    '4144672248660824652311280789227568759501644435839088465487215978090977152836',
    '16580012705864177241905923711864666027965216928284588602669501632136706453456',
    '28268897103231723777184618409092967932555901943057586428182153116992131011025',
  ],
  'MinaZkappEvents*****': [
    '22941690192200157010958144262626906691861453230235765939870625581651903942109',
    '8085194290973996063041942057794139208480036474122767282118588735695477304146',
    '26729904183313179836453835886592671283117737890095730465188585661277543615385',
  ],
  'MinaZkappSeqEvents**': [
    '20111532619758468729019280527752703188436440291616049387250019116440725105679',
    '28272901079534355755544153990297346241256584111406088887261772513761686581936',
    '11593971643819429831651280663135869674712971584194549509498204047075895747923',
  ],
  'MinaZkappMemo*******': [
    '2662735671148484138098041239517130399444285195614926917304994766121342901330',
    '1889560324711062089177091328630260720221153765601231238715650562289804935970',
    '4150523804923664151142435309968051550133270766858171566059780615187901817023',
  ],
  'MinaZkappTest*******': [
    '23523101868899742954180674496902908392567863852999903167375927084079494055612',
    '4491786955849351692402874941062803293792761915358826996649017458255778371918',
    '18160445324611651688025194683090940451613686777550031421971998315243738422364',
  ],
  'MinaDeriveTokenId***': [
    '6192019453766080264591455948244350296532066491511280821771403784079613278630',
    '3474280028978446563781013959252007045004226094384968366087940198662654278266',
    '20434002876694963787609307807174199928279086350854834006718281273564667456637',
  ],
  CodaReceiptEmpty: [
    '14564582992068613478915821183083107733064540968050799295374021047658500056219',
    '21765043973285063733734239399942750176857972907855721619600674857294623000734',
    '18519955733587546799174091248819038069762857427193969217428957100491271613694',
  ],
  MinaZkappEventsEmpty: [
    '11558119263070965853863267079253872832625419457395008685779236645292569607921',
    '25458142203119307439619503192644060065091275427503371449742352140981637359577',
    '28343474290528262467651243371210869540984529302238754668057531270656874883506',
  ],
  MinaZkappActionsEmpty: [
    '2965377540200775924504968637505084669999360240500907972788072774778139588064',
    '17888733104410001265760460027725887240172765470923695174284923303416908725309',
    '6155733123951817300356401771271939707310716210385193729101357561319788034953',
  ],
  MinaZkappActionStateEmptyElt: [
    '25079927036070901246064867767436987657692091363973573142121686150614948079097',
    '26431778411571512074795067173224334387034335867358343719815640998216694007738',
    '25080775363764450744501815075506845022058095277795060631172637381645274354727',
  ],
  CoinbaseStack: [
    '13478948633790621346997153068092516261975764161208078295837519850718904039733',
    '23794571567771902109532327523992257297445027552423990566905688786749549749640',
    '12437776415960587857483436445253285567999534294199440886476575966193776753527',
  ],
  PendingCoinbaseMerkleTree: [
    '21962074494103541153175746450273873003299668759086391980006382367241943398196',
    '2903435713642676558047328375873609628346075739786101737671585224825766548393',
    '25831764682100331646870313396659195191400312071282528592914032765816857800473',
  ],
  'MinaMklTree000******': [
    '8397268313679062041369959431253823194029931472150942928062160502284391094281',
    '24767884761786058961844271624848183563027832662151526765582126547150580343286',
    '15520161476079946346223794435136450862321049619449569410496603974021593252201',
  ],
  'MinaMklTree001******': [
    '12373852158717286419843731546435335382149645091717657472272709119680142489615',
    '13564003298811293044133692367818358732199958610489782205113648738971877309993',
    '5337043262085238844960907983211959910580364187637104432942748885155441259131',
  ],
  'MinaMklTree002******': [
    '15051812550454916172932351641588540140427950452718257831984749683884179659477',
    '28383195182051628320454520194171815630993209993126957580698595309541504912011',
    '4277691878710291748308373204686233213493236676960343422888557635834505390473',
  ],
  'MinaMklTree003******': [
    '6575607106027019342374634884807079936125440627705088279356425488661046931690',
    '526224612349672274315011399400566806883023700724847451269254308717318755497',
    '4003207773096098875040917033101823533304203798100315080652105415888406223352',
  ],
  'MinaMklTree004******': [
    '24963240007694741581504536598446662705874548366155724154174858737449434658477',
    '3025643334447992593201368502593388460692780911680818037147500927887943605498',
    '17577291971615136405466944877064852825800866932005309965300049909875838083076',
  ],
  'MinaMklTree005******': [
    '11625519336224216740433997623839523639549293720171430638848267458495647838261',
    '14197827690168556134026805733901328807809311762374992007209622464122527394871',
    '24909546339148248646747762490876591451430974658068769530058833648954096301456',
  ],
  'MinaMklTree006******': [
    '20496141241824212441237352225390586578798287226209999878764321364949616437960',
    '4155590369081069691345914612081918410248481482116023511739814856893535749559',
    '25280235590916436988517501437699802702512719636909687680088402215172012465734',
  ],
  'MinaMklTree007******': [
    '10298068926909347382132883731000773194312572157088286708479172422210086260995',
    '14412862431845107093626156618901720148499279341044373322107997590840338638158',
    '18738278293927842151520671915277777211638038066182255367951771829184874598427',
  ],
  'MinaMklTree008******': [
    '28632592040294076899303724277173923788865287530305670556694222869732793988004',
    '14134336299867672225741933845142646509776280694779004162993533642733541282015',
    '28037399410478206961594894531712592987717708818866863005767179190210518183828',
  ],
  'MinaMklTree009******': [
    '28322440793030270460307522165077799886504360112793805560745845785393893720792',
    '3680990636041985093510751436516424061735738733660682549379374982251492126646',
    '7896824890513378496611723513283689788600212799489558200026291296328182622221',
  ],
  'MinaMklTree010******': [
    '1478825754917601949043978332728751378179798684550333324122027096810422078645',
    '19955446483411426559697602372431961972639316232014088927090908136220581190127',
    '22937261898125224845285209761802309482795401959887338893419704202246881755471',
  ],
  'MinaMklTree011******': [
    '3025669655948979260146450778546273335663805909503078623788468939889184085065',
    '15993847354573651974906488175776892699808218007882158173582011967178852672755',
    '6728962834255630075044411175238909144357249010478126045082535701512206099100',
  ],
  'MinaMklTree012******': [
    '4677165292950275428044379611682530196143565581952109747023715412205031133122',
    '21513899673761352699672092079955767010402365369617552725870531290648558067173',
    '5823386711670711136557441661686775439019939642112594994252954772574341048476',
  ],
  'MinaMklTree013******': [
    '4137450619603133353679529278148472140169709465994051450094506977210968350741',
    '20777878603100506442428451439085789382190751853558867746947762486311334171694',
    '27969424486066619381654224557897167292901506145568220790334189049235066613665',
  ],
  'MinaMklTree014******': [
    '7462353831830439752760657933641455151117269082035084708085558232378403435178',
    '1787244519320006617494344121814759180988090836648336932002915182844592150859',
    '7682306724592829108592527309756770669512991144597346665572702844909814248134',
  ],
  'MinaMklTree015******': [
    '12849982892801603879697133836957604723592408109307896931233575279534184819695',
    '27109175861581264256359157262042451197946512419680432940872313012019233881553',
    '13815104575456051899693190094329831931582197916170277640933492195480185919492',
  ],
  'MinaMklTree016******': [
    '6644594317394622409746632037064067639690803096240195936787541353591870145229',
    '11503303739151441813791807558499068063822922776334355558577285976158398952971',
    '9337125879737469121869180649342064063336965090821029559184624332617319461193',
  ],
  'MinaMklTree017******': [
    '16104414183099799176590675567463444044322697144434744941137050377134055108298',
    '17358877713925634221311853575857896650017793698150943722268889332978652414223',
    '7234126597295300967301107936467282549695978865424211233580228640451399578381',
  ],
  'MinaMklTree018******': [
    '17030714373021103124485584722642520216144771996601835120521405613273080127695',
    '26509950438240323122836106956137067463028271669140328718474012128935499432293',
    '9818889955393545543887790759741008577636326202190253983607321653665940190431',
  ],
  'MinaMklTree019******': [
    '2270411531086562128123060093007384197084198453711890037231329803621300858719',
    '21192327485899043676835708468201514580084416399939158033379551466586666938111',
    '16033989106273371309578845565218498940092011786025881685960320194668952032796',
  ],
  'MinaMklTree020******': [
    '24198821385641779512630219367024089801694762674171638444197433117564329069692',
    '17399215024068249103454892742127252703846599060950907551709080066119343928674',
    '6797496550859701647209308902606013125966581359799331801777446461476502619719',
  ],
  'MinaMklTree021******': [
    '15260363122901687259348044007172490341059494245069079855983853109440904252201',
    '21842382560395200222478365766257143008580907092198481707074219770380221343296',
    '19876442709041612567866226719534012751674476537343454328432936802993088542055',
  ],
  'MinaMklTree022******': [
    '10163265845587027789352563667609980510844248093141311984644246724416434726269',
    '13369107363202464111086659762824590159914641657154062683624651983805608000703',
    '259175261445126704640807316250901216510411826120741654939526054707099272571',
  ],
  'MinaMklTree023******': [
    '25461412540439968937539737336272713843660028687121793297700520674608023616092',
    '10755893000209302712577283259218096030828962406298481790491258793159046533447',
    '8866387537961409494137849949417794325538964245944495058838310355591599158861',
  ],
  'MinaMklTree024******': [
    '10609060102237336747496673704618826236585593118726760088941627829244492026235',
    '6641853671926028367004819143507613339775735721213578606129119394262986889972',
    '9176598236393962999771652301435919857376442200780273350376009302991599772639',
  ],
  'MinaMklTree025******': [
    '8743110049886111146439413671080530377154252710287926017043338548443560750915',
    '18208706295395849104423491533560000448355322792628322573027110778397939938163',
    '2334327064299326913052261993744862803507079864714736582625500368508312407812',
  ],
  'MinaMklTree026******': [
    '5402818389523730021623225031229797943489634186744070457165886896537635439065',
    '3692115584159570188352953749250318597861823862334166671448537184963748474804',
    '6395188055016804845192781987569287073677422173381065069566010090740896063910',
  ],
  'MinaMklTree027******': [
    '23003820738793392288354347717848227276238967632076473726115713990146403158695',
    '1543444712754301638361713310613005045560110448825211620606741790481631721785',
    '25595274127363608001744519321284450036093000747866790144244029941400855918414',
  ],
  'MinaMklTree028******': [
    '1371490494959146551400088557556657100677286767912367568372761029147549710248',
    '9732076291970119043155961140210107725581877672949581468560495192803834949972',
    '25880816593631896400945395886425311206250378130295778852027160152013445398428',
  ],
  'MinaMklTree029******': [
    '5026966843162353429404633270081859806361860129654116093869475139616692501822',
    '14399077456078098196809897303466976088446801284524532382221120510698115179718',
    '19173688776848337916142856590169111672948615917148745778746830767290062051975',
  ],
  'MinaMklTree030******': [
    '28464430208663194459267079800760461073547794864536029383346306150717295227411',
    '28914474904259440678682001469840084119186056954595456498123242804122927256626',
    '26203211860047183178968105249611310661035109372798510229151816437426414875870',
  ],
  'MinaMklTree031******': [
    '10406444365958122823322321566809921419619436370846100318015238317663537713508',
    '19324027736939870254907794657369430751886546066724762856165204189536200502231',
    '27910908481683556223061499853457824695327274417786658997051526597466420105059',
  ],
  'MinaMklTree032******': [
    '1799233325885428173215288721205732918055309618518578057591098186182492814731',
    '9573156486615047627167271384099786785626031045209045718144391096893253044237',
    '21011100500969260736212187791129169911216589801480194154796681238630801173303',
  ],
  'MinaMklTree033******': [
    '3148460134537259154192780209825660438770489205065565102219398141630842726179',
    '10416076901773723654263170420888517757942744365709722512723508899712187445722',
    '9749070751601048371099954046702168187173097100747088073519924283619949053060',
  ],
  'MinaMklTree034******': [
    '16036605154418397696690227738898261818934103448455753144542686857246049934251',
    '13116195790811852398580983299275910910260911290232634459841017490947920635760',
    '20914357145334136112903459144371894839046767011252485660349261543687439240515',
  ],
};
let prefixHashesLegacy = {
  'CodaReceiptUC*******': [
    '17081977821176270994512651394491195177111442160604726653596300537904083542874',
    '22524836078442467808299966370016521142448937585030982609163888361124501146539',
    '12924279821307137198726349959646209575189430925513631516289320462608412110369',
  ],
  MinaSignatureMainnet: [
    '25220214331362653986409717908235786107802222826119905443072293294098933388948',
    '7563646774167489166725044360539949525624365058064455335567047240620397351731',
    '171774671134240704318655896509797243441784148630375331692878460323037832932',
  ],
  'CodaSignature*******': [
    '28132119227444686413214523693400847740858213284875453355294308721084881982354',
    '24895072146662946646133617369498198544578131474807621989761680811592073367193',
    '3216013753133880902260672769141972972810073620591719805178695684388949134646',
  ],
};
let versionBytes = {
  tokenIdKey: 28,
  receiptChainHash: 12,
  ledgerHash: 5,
  epochSeed: 13,
  stateHash: 16,
  publicKey: 203,
  userCommandMemo: 20,
  privateKey: 90,
  signature: 154,
  transactionHash: 29,
  signedCommandV1: 19,
};
let protocolVersions = { txnVersion: 3 };
let poseidonParamsKimchiFp = {
  mds: [
    [
      '12035446894107573964500871153637039653510326950134440362813193268448863222019',
      '25461374787957152039031444204194007219326765802730624564074257060397341542093',
      '27667907157110496066452777015908813333407980290333709698851344970789663080149',
    ],
    [
      '4491931056866994439025447213644536587424785196363427220456343191847333476930',
      '14743631939509747387607291926699970421064627808101543132147270746750887019919',
      '9448400033389617131295304336481030167723486090288313334230651810071857784477',
    ],
    [
      '10525578725509990281643336361904863911009900817790387635342941550657754064843',
      '27437632000253211280915908546961303399777448677029255413769125486614773776695',
      '27566319851776897085443681456689352477426926500749993803132851225169606086988',
    ],
  ],
  roundConstants: [
    [
      '21155079691556475130150866428468322463125560312786319980770950159250751855431',
      '16883442198399350202652499677723930673110172289234921799701652810789093522349',
      '17030687036425314703519085065002231920937594822150793091243263847382891822670',
    ],
    [
      '25216718237129482752721276445368692059997901880654047883630276346421457427360',
      '9054264347380455706540423067244764093107767235485930776517975315876127782582',
      '26439087121446593160953570192891907825526260324480347638727375735543609856888',
    ],
    [
      '15251000790817261169639394496851831733819930596125214313084182526610855787494',
      '10861916012597714684433535077722887124099023163589869801449218212493070551767',
      '18597653523270601187312528478986388028263730767495975370566527202946430104139',
    ],
    [
      '15831416454198644276563319006805490049460322229057756462580029181847589006611',
      '15171856919255965617705854914448645702014039524159471542852132430360867202292',
      '15488495958879593647482715143904752785889816789652405888927117106448507625751',
    ],
    [
      '19039802679983063488134304670998725949842655199289961967801223969839823940152',
      '4720101937153217036737330058775388037616286510783561045464678919473230044408',
      '10226318327254973427513859412126640040910264416718766418164893837597674300190',
    ],
    [
      '20878756131129218406920515859235137275859844638301967889441262030146031838819',
      '7178475685651744631172532830973371642652029385893667810726019303466125436953',
      '1996970955918516145107673266490486752153434673064635795711751450164177339618',
    ],
    [
      '15205545916434157464929420145756897321482314798910153575340430817222504672630',
      '25660296961552699573824264215804279051322332899472350724416657386062327210698',
      '13842611741937412200312851417353455040950878279339067816479233688850376089318',
    ],
    [
      '1383799642177300432144836486981606294838630135265094078921115713566691160459',
      '1135532281155277588005319334542025976079676424839948500020664227027300010929',
      '4384117336930380014868572224801371377488688194169758696438185377724744869360',
    ],
    [
      '21725577575710270071808882335900370909424604447083353471892004026180492193649',
      '676128913284806802699862508051022306366147359505124346651466289788974059668',
      '25186611339598418732666781049829183886812651492845008333418424746493100589207',
    ],
    [
      '10402240124664763733060094237696964473609580414190944671778761753887884341073',
      '11918307118590866200687906627767559273324023585642003803337447146531313172441',
      '16895677254395661024186292503536662354181715337630376909778003268311296637301',
    ],
    [
      '23818602699032741669874498456696325705498383130221297580399035778119213224810',
      '4285193711150023248690088154344086684336247475445482883105661485741762600154',
      '19133204443389422404056150665863951250222934590192266371578950735825153238612',
    ],
    [
      '5515589673266504033533906836494002702866463791762187140099560583198974233395',
      '11830435563729472715615302060564876527985621376031612798386367965451821182352',
      '7510711479224915247011074129666445216001563200717943545636462819681638560128',
    ],
    [
      '24694843201907722940091503626731830056550128225297370217610328578733387733444',
      '27361655066973784653563425664091383058914302579694897188019422193564924110528',
      '21606788186194534241166833954371013788633495786419718955480491478044413102713',
    ],
    [
      '19934060063390905409309407607814787335159021816537006003398035237707924006757',
      '8495813630060004961768092461554180468161254914257386012937942498774724649553',
      '27524960680529762202005330464726908693944660961000958842417927307941561848461',
    ],
    [
      '15178481650950399259757805400615635703086255035073919114667254549690862896985',
      '16164780354695672259791105197274509251141405713012804937107314962551600380870',
      '10529167793600778056702353412758954281652843049850979705476598375597148191979',
    ],
    [
      '721141070179074082553302896292167103755384741083338957818644728290501449040',
      '22044408985956234023934090378372374883099115753118261312473550998188148912041',
      '27068254103241989852888872162525066148367014691482601147536314217249046186315',
    ],
    [
      '3880429241956357176819112098792744584376727450211873998699580893624868748961',
      '17387097125522937623262508065966749501583017524609697127088211568136333655623',
      '6256814421247770895467770393029354017922744712896100913895513234184920631289',
    ],
    [
      '2942627347777337187690939671601251987500285937340386328746818861972711408579',
      '24031654937764287280548628128490074801809101323243546313826173430897408945397',
      '14401457902976567713827506689641442844921449636054278900045849050301331732143',
    ],
    [
      '20170632877385406450742199836933900257692624353889848352407590794211839130727',
      '24056496193857444725324410428861722338174099794084586764867109123681727290181',
      '11257913009612703357266904349759250619633397075667824800196659858304604714965',
    ],
    [
      '22228158921984425749199071461510152694025757871561406897041788037116931009246',
      '9152163378317846541430311327336774331416267016980485920222768197583559318682',
      '13906695403538884432896105059360907560653506400343268230130536740148070289175',
    ],
    [
      '7220714562509721437034241786731185291972496952091254931195414855962344025067',
      '27608867305903811397208862801981345878179337369367554478205559689592889691927',
      '13288465747219756218882697408422850918209170830515545272152965967042670763153',
    ],
    [
      '8251343892709140154567051772980662609566359215743613773155065627504813327653',
      '22035238365102171608166944627493632660244312563934708756134297161332908879090',
      '13560937766273321037807329177749403409731524715067067740487246745322577571823',
    ],
    [
      '21652518608959234550262559135285358020552897349934571164032339186996805408040',
      '22479086963324173427634460342145551255011746993910136574926173581069603086891',
      '13676501958531751140966255121288182631772843001727158043704693838707387130095',
    ],
    [
      '5680310394102577950568930199056707827608275306479994663197187031893244826674',
      '25125360450906166639190392763071557410047335755341060350879819485506243289998',
      '22659254028501616785029594492374243581602744364859762239504348429834224676676',
    ],
    [
      '23101411405087512171421838856759448177512679869882987631073569441496722536782',
      '24149774013240355952057123660656464942409328637280437515964899830988178868108',
      '5782097512368226173095183217893826020351125522160843964147125728530147423065',
    ],
    [
      '13540762114500083869920564649399977644344247485313990448129838910231204868111',
      '20421637734328811337527547703833013277831804985438407401987624070721139913982',
      '7742664118615900772129122541139124149525273579639574972380600206383923500701',
    ],
    [
      '1109643801053963021778418773196543643970146666329661268825691230294798976318',
      '16580663920817053843121063692728699890952505074386761779275436996241901223840',
      '14638514680222429058240285918830106208025229459346033470787111294847121792366',
    ],
    [
      '17080385857812672649489217965285727739557573467014392822992021264701563205891',
      '26176268111736737558502775993925696791974738793095023824029827577569530708665',
      '4382756253392449071896813428140986330161215829425086284611219278674857536001',
    ],
    [
      '13934033814940585315406666445960471293638427404971553891617533231178815348902',
      '27054912732979753314774418228399230433963143177662848084045249524271046173121',
      '28916070403698593376490976676534962592542013020010643734621202484860041243391',
    ],
    [
      '24820015636966360150164458094894587765384135259446295278101998130934963922381',
      '7969535238488580655870884015145760954416088335296905520306227531221721881868',
      '7690547696740080985104189563436871930607055124031711216224219523236060212249',
    ],
    [
      '9712576468091272384496248353414290908377825697488757134833205246106605867289',
      '12148698031438398980683630141370402088785182722473169207262735228500190477924',
      '14359657643133476969781351728574842164124292705609900285041476162075031948227',
    ],
    [
      '23563839965372067275137992801035780013422228997724286060975035719045352435470',
      '4184634822776323233231956802962638484057536837393405750680645555481330909086',
      '16249511905185772125762038789038193114431085603985079639889795722501216492487',
    ],
    [
      '11001863048692031559800673473526311616702863826063550559568315794438941516621',
      '4702354107983530219070178410740869035350641284373933887080161024348425080464',
      '23751680507533064238793742311430343910720206725883441625894258483004979501613',
    ],
    [
      '28670526516158451470169873496541739545860177757793329093045522432279094518766',
      '3568312993091537758218792253361873752799472566055209125947589819564395417072',
      '1819755756343439646550062754332039103654718693246396323207323333948654200950',
    ],
    [
      '5372129954699791301953948907349887257752247843844511069896766784624930478273',
      '17512156688034945920605615850550150476471921176481039715733979181538491476080',
      '25777105342317622165159064911913148785971147228777677435200128966844208883059',
    ],
    [
      '25350392006158741749134238306326265756085455157012701586003300872637887157982',
      '20096724945283767296886159120145376967480397366990493578897615204296873954844',
      '8063283381910110762785892100479219642751540456251198202214433355775540036851',
    ],
    [
      '4393613870462297385565277757207010824900723217720226130342463666351557475823',
      '9874972555132910032057499689351411450892722671352476280351715757363137891038',
      '23590926474329902351439438151596866311245682682435235170001347511997242904868',
    ],
    [
      '17723373371137275859467518615551278584842947963894791032296774955869958211070',
      '2350345015303336966039836492267992193191479606566494799781846958620636621159',
      '27755207882790211140683010581856487965587066971982625511152297537534623405016',
    ],
    [
      '6584607987789185408123601849106260907671314994378225066806060862710814193906',
      '609759108847171587253578490536519506369136135254150754300671591987320319770',
      '28435187585965602110074342250910608316032945187476441868666714022529803033083',
    ],
    [
      '16016664911651770663938916450245705908287192964254704641717751103464322455303',
      '17551273293154696089066968171579395800922204266630874071186322718903959339163',
      '20414195497994754529479032467015716938594722029047207834858832838081413050198',
    ],
    [
      '19773307918850685463180290966774465805537520595602496529624568184993487593855',
      '24598603838812162820757838364185126333280131847747737533989799467867231166980',
      '11040972566103463398651864390163813377135738019556270484707889323659789290225',
    ],
    [
      '5189242080957784038860188184443287562488963023922086723850863987437818393811',
      '1435203288979376557721239239445613396009633263160237764653161500252258220144',
      '13066591163578079667911016543985168493088721636164837520689376346534152547210',
    ],
    [
      '17345901407013599418148210465150865782628422047458024807490502489711252831342',
      '22139633362249671900128029132387275539363684188353969065288495002671733200348',
      '1061056418502836172283188490483332922126033656372467737207927075184389487061',
    ],
    [
      '10241738906190857416046229928455551829189196941239601756375665129874835232299',
      '27808033332417845112292408673209999320983657696373938259351951416571545364415',
      '18820154989873674261497645724903918046694142479240549687085662625471577737140',
    ],
    [
      '7983688435214640842673294735439196010654951226956101271763849527529940619307',
      '17067928657801807648925755556866676899145460770352731818062909643149568271566',
      '24472070825156236829515738091791182856425635433388202153358580534810244942762',
    ],
    [
      '25752201169361795911258625731016717414310986450004737514595241038036936283227',
      '26041505376284666160132119888949817249574689146924196064963008712979256107535',
      '23977050489096115210391718599021827780049209314283111721864956071820102846008',
    ],
    [
      '26678257097278788410676026718736087312816016749016738933942134600725962413805',
      '10480026985951498884090911619636977502506079971893083605102044931823547311729',
      '21126631300593007055117122830961273871167754554670317425822083333557535463396',
    ],
    [
      '1564862894215434177641156287699106659379648851457681469848362532131406827573',
      '13247162472821152334486419054854847522301612781818744556576865965657773174584',
      '8673615954922496961704442777870253767001276027366984739283715623634850885984',
    ],
    [
      '2794525076937490807476666942602262298677291735723129868457629508555429470085',
      '4656175953888995612264371467596648522808911819700660048695373348629527757049',
      '23221574237857660318443567292601561932489621919104226163978909845174616477329',
    ],
    [
      '1878392460078272317716114458784636517603142716091316893054365153068227117145',
      '2370412714505757731457251173604396662292063533194555369091306667486647634097',
      '17409784861870189930766639925394191888667317762328427589153989811980152373276',
    ],
    [
      '25869136641898166514111941708608048269584233242773814014385564101168774293194',
      '11361209360311194794795494027949518465383235799633128250259863567683341091323',
      '14913258820718821235077379851098720071902170702113538811112331615559409988569',
    ],
    [
      '12957012022018304419868287033513141736995211906682903915897515954290678373899',
      '17128889547450684566010972445328859295804027707361763477802050112063630550300',
      '23329219085372232771288306767242735245018143857623151155581182779769305489903',
    ],
    [
      '1607741027962933685476527275858938699728586794398382348454736018784568853937',
      '2611953825405141009309433982109911976923326848135736099261873796908057448476',
      '7372230383134982628913227482618052530364724821976589156840317933676130378411',
    ],
    [
      '20203606758501212620842735123770014952499754751430660463060696990317556818571',
      '4678361398979174017885631008335559529633853759463947250620930343087749944307',
      '27176462634198471376002287271754121925750749676999036165457559387195124025594',
    ],
    [
      '6361981813552614697928697527332318530502852015189048838072565811230204474643',
      '13815234633287489023151647353581705241145927054858922281829444557905946323248',
      '10888828634279127981352133512429657747610298502219125571406085952954136470354',
    ],
  ],
  fullRounds: 55,
  partialRounds: 0,
  hasInitialRoundConstant: false,
  stateSize: 3,
  rate: 2,
  power: 7,
};
let poseidonParamsLegacyFp = {
  mds: [
    [
      '5328350144166205084223774245058198666309664348635459768305312917086056785354',
      '15214731724107930304595906373487084110291887262136882623959435918484004667388',
      '22399519358931858664262538157042328690232277435337286643350379269028878354609',
    ],
    [
      '10086628405675314879458652402278736459294354590428582803795166650930540770072',
      '17127968360683744052278857147989507037142007029142438136689352416106177192235',
      '14207324749280135281015658576564097509614634975132487654324863824516044294735',
    ],
    [
      '3059104278162906687184746935153057867173086006783171716838577369156969739687',
      '16755849208683706534025643823697988418063305979108082130624352443958404325985',
      '16889774624482628108075965871448623911656600744832339664842346756371603433407',
    ],
  ],
  roundConstants: [
    [
      '1346081094044643970582493287085428191977688221215786919106342366360741041016',
      '10635969173348128974923358283368657934408577270968219574411363948927109531877',
      '18431955373344919956072236142080066866861234899777299873162413437379924987003',
    ],
    [
      '5797044060651575840084283729791357462720161727701814038830889113712361837236',
      '931288489507796144596974766082847744938192694315568692730730202141894005205',
      '13659894470945121760517769979107966886673294523737498361566285362771110125394',
    ],
    [
      '6076231707445968054305995680347976771585015308155855387339303513025362636128',
      '28822740034050339685362260108484262889265034407340240070058997651710236456303',
      '23420266473857869790486107029614186913447272961845992963194006142267563993493',
    ],
    [
      '13753917374184785903125509246122783296344288469304898921025291716613575849357',
      '22396739346703340038555577564698139382745239004673153148674304627904081092826',
      '13064238335532551154986111986409392866270911640785653458047811526842088084911',
    ],
    [
      '23165923875642452719095776619341762858050322341374771345641255745672274104746',
      '1876216571769482372914291210815859835162659440705283782713345335434924136736',
      '25448252060136178247213604035267580231762596830634036926922217427938159849142',
    ],
    [
      '2161875315509206970842862195937323600322108268401381254431163181777726747153',
      '19159855698625842998331760283165907305622417625829203038229273729196960321630',
      '24828563875172432296791053766778475681869974948122169083176331088266823626561',
    ],
    [
      '15959479662608710141128458274961057999257961784282074767105536637788386907463',
      '8006369581283017287449277389162056290714176164680299906116833200510117952858',
      '18794336794618132129607701188430371953320538976527988886453665523008714542779',
    ],
    [
      '19408271715954593722501381885401160867835377473312521553027032015227895029571',
      '13654747284005184272412579731446984220568337794941823533879059135026064413631',
      '14094055032353750931629930778481002727722804310855727808905931659115939920989',
    ],
    [
      '13241818625838429282823260827177433104574315653706102174619924764342778921524',
      '25709259239494174564705048436260891089407557689981668111890003079561388887725',
      '26866626910239634723971078462134580196819809568632305020800296809092442642381',
    ],
    [
      '23886826350713085163238005260075062110062681905356997481925492650252417143049',
      '16853602711255261520713463306790360324679500458440235992292027384928526778856',
      '18444710386168488194610417945072711530390091945738595259171890487504771614189',
    ],
    [
      '16896789009769903615328691751424474161656500693270070895928499575572871141439',
      '23842266984616972287898037872537536999393060934879414668030219493005225085992',
      '24369698563802298585444760814856330583118549706483939267059237951238240608187',
    ],
    [
      '25360195173713628054110426524260405937218170863260484655473435413697869858790',
      '1486437708678506228822038923353468635394979165769861487132708983207562337116',
      '18653498960429911228442559598959970807723487073275324556015861725806677047150',
    ],
    [
      '18878179044241268037057256060083772636369783391816038647949347814518015576522',
      '178715779905629247116805974152863592571182389085419970371289655361443016848',
      '8381006794425876451998903949255801618132578446062133243427381291481465852184',
    ],
    [
      '4176946262813877719206528849579392120806054050640974718891398605746592169324',
      '16376345520728802444699629729684297833862527190772376028981704525651968727081',
      '8399065769082251057361366626601550736334213197703006866551331927128775757919',
    ],
    [
      '15435308585611812393531506745122614542196708285088622615406141986333182280857',
      '4082259282787276939431186930090898350392871145699460879678141552997816391817',
      '26348742719959309014730178326877937464605873211235784184917342950648457078699',
    ],
    [
      '9707631711734344681918469569872517425107158187591261754498805460753455298868',
      '27910768846011709391567916011595957279088224137468948238696800459136335473132',
      '20407239095656434708569263842372155762970847207558227886302782130015730063802',
    ],
    [
      '22726225412881182965250630589245572283256255052470345984553083359461473893802',
      '12443967854426795490638709950679156338200426963050610832781263082981525248175',
      '27102543658848146076219989119639465430524061997280788166887046421706499775415',
    ],
    [
      '14427224233985680214097547669945064793149553513421479297921556194475574770861',
      '22917454832925781549840198815703114840452733537799472739275668965081704937832',
      '3455076056123630366063931123762198941796412458154689469887583689725886013901',
    ],
    [
      '4513100023937785913596662867311227004762025658663076805918211014066645403017',
      '18187619530784075723418065322038024507729605774832001333883311123910954334059',
      '9447065431426150382325592560406989926365684509675374414068135115024495130938',
    ],
    [
      '3227816098015819796753427754968234889554095489076864339942014527747604603014',
      '14798316759185072116520458171957899889489461918408669809912344751222514418582',
      '23013904852315603905843158448056763116188801262838729536210355401378476650033',
    ],
    [
      '20979191509934291452182967564058656088941447895799901211038858159903580333267',
      '20772973010251235271448378823573767262405703078344288856168565499702414379868',
      '10105446427739226002497411811738001382334316505480517822035303561899927603685',
    ],
    [
      '11079074761356717003579108002319997196881121172538617046865136940931215263187',
      '4693927775411489288330326150094711670434597808961717172753867514688725690438',
      '18581720304902876944842830383273503265470859268712618325357902881821721540119',
    ],
    [
      '3065369948183164725765083504606321683481629263177690053939474679689088169185',
      '18515622379147081456114962668688706121098539582467584736624699157043365677487',
      '17563088600719312877716085528177751048248154461245613291986010180187238198006',
    ],
    [
      '26199746176994924146211004840756471702409132230831594954444947705902602287290',
      '7576136600627345523051497639367002272003104458453478964661395239732811642605',
      '20058687874612168338994287374025378897088936171250328231848098497610185784281',
    ],
    [
      '16894722532414195606958290526999761110785277556463400588047573469106594850228',
      '13961730805696859614283621225672002906734926278118993580398533742874863598733',
      '25256842011135514243352951950573936602906198374305137963222382546140030647211',
    ],
    [
      '18530360047537856737482157200091774590035773602620205695980247565433703032532',
      '23014819965938599260086897799541446473887833964178378497976832161473586995397',
      '27911426213258307990762460361663504655967992659180759140364181941291843542489',
    ],
    [
      '1067338118323302017358103178057182291035336430305886255160210378977812067042',
      '17219092885519007424608854460610388434712113621163885775309496940189894433620',
      '16432921127615937542183846559291144733339643093361323334499888895135356545408',
    ],
    [
      '28608851042959977114787048070153637607786033079364369200270218128830983558707',
      '10121629780013165888398831090128011045011860641816380162950736555305748332191',
      '2348036340843128746981122630521268144839343500596932561106759754644596320722',
    ],
    [
      '16619881370356823200358060093334065394764987467483650323706184068451904156452',
      '2302436627861989749837563733434625231689351276818486757748445924305258835336',
      '27514536540953539473280001431110316405453388911725550380123851609652679788049',
    ],
    [
      '9459277727420672604737117687200019308525004979918488827092207438664125039815',
      '23425670740358068509956137586663046763224562225383386726193078231034380596217',
      '7641885067011661443791509688937280323563328029517832788240965464798835873658',
    ],
    [
      '9579420382351699601929202663836555665702024548386778299996961509578687980280',
      '18513671386572584282611234979588379470994484682444053600751415262497237017703',
      '24923151431234706142737221165378041700050312199585085101919834422744926421604',
    ],
    [
      '21131320841803068139502705966375283830095161079635803028011171241658723560073',
      '19208476595309656066589572658712717685014329237892885950958199953675225096566',
      '24023185216737416080949689106968568821656545490748664446389634158498624398204',
    ],
    [
      '7510552996848634969347937904645640209946785877619890235458182993413526028718',
      '3694415017252995094553868781762548289196990492336482360084813900937464847638',
      '9219021070107873028263141554048987416559034633883158827414043929220388719352',
    ],
    [
      '5058327241234443421111591959922712922949620710493120384930391763032694640881',
      '13148252221647574076185511663661016015859769210867362839817254885265598775418',
      '15186790492457240277904880519227706403545816456632095870015828239411033220638',
    ],
    [
      '2775942914650502409705888572245750999561427024488403026572311267798009048466',
      '6277965230841030155341171319927732572492215818164736949144854827643964384893',
      '24144742149845235561087977558785057713814731737434473021812189457617252043745',
    ],
    [
      '25789129719327437503403457598813971826156253950521984610569937361506914183550',
      '21500534320778995945845999974779950304491968082325255355181901574840373597824',
      '17185359848218837018503091932245529880546896465437232425673134558221638601375',
    ],
    [
      '12253896579078110143384981818031883112606762215016553811786428215758384195713',
      '12956658260778456372481429232709881794962204180363200699121804724437678625542',
      '3023603786717368708677300377055384474816569333060487675635618249403832078921',
    ],
    [
      '4186492855716808019562789862833898284927736051002588766326482010810259565130',
      '4263939782228419774639068267872291539552889472311225829898746091327730032923',
      '24068843626280451423530509388397151179174104901782990365720205643492047328816',
    ],
    [
      '14564937827374621319716285527475223392664010281568256859627186463065876537730',
      '28367596550218705971881480694115935470211319172596432472834880507822452927283',
      '28712267437482356021504544448225827500268648754270274754623969882031853409874',
    ],
    [
      '4542596163006916397403529184431773692747461300288194722982487051249951403191',
      '2530461821259252672899452671728393208543894014761816288817584587718369998371',
      '12886393063011539390567049190923398676964700147222878509238966758839020897414',
    ],
    [
      '21593897590707514492037699253654745501762191795293908682495110982956631870528',
      '13233005790593128135480716846773978578237145313006994631606474472023504621256',
      '21621863098292803642478350494794106282518362577273973885587684567452726939909',
    ],
    [
      '26068620073001644720969640099644251616742620988609091568084348314770436291745',
      '18248589586787935500122854210401321966459127818593446990365211078521058875685',
      '21247134484403265289037859533347798468858819117600251067578809852124865474448',
    ],
    [
      '7947383127165915366383984718363902897504221803836013123394785749404572432524',
      '22173041014621867335598230447618036223462011647696367239478182269973488867154',
      '16773227734018849308448505860847939069870370055633571816925675705713088305139',
    ],
    [
      '10708707957340055662073314227607620808612686977606082605219160019699644826999',
      '21249897193797038261479589555720746994050836195265348846222835266344091683000',
      '12581195059139097540117398803363514148192715293133623516709277290477633379593',
    ],
    [
      '19779599816866992123290302397082614570282926215253589712189610064229996603178',
      '21749216503901548676985371189807470207364320167486559936962401093285243029177',
      '17600045923623503357380202389718735904174992978547372448837488832457719009224',
    ],
    [
      '2732872979548118117758016335601225525660858727422778256671975055129965858636',
      '13703031005128062046175331918702218558750713240446179585947851411173844703597',
      '28447710105386636841938034820015573492556750872924193415447818187228356409281',
    ],
    [
      '28539960355005748517007309210788803416171161412204526246799800716567376494244',
      '21329318452221893900731030722137844458345358926323127858742388587761302609863',
      '28135302149599894709369178097439582767613940517471323224020113411362601191873',
    ],
    [
      '24980774120400248734054527936006392540889095705961960837980443629260392758683',
      '20339911045808632098936066397942175169549806052128535543540543556255197716643',
      '7929293103930252545581851978492699598413941396422930641071359388697302362494',
    ],
    [
      '8911092207145893152276662096451247820054843777071569723455408545101628926203',
      '19648860643145256523615441075182036100116634560394529500146405733687718224516',
      '14635387208623683806428528837466762532853903031263830054986064902455379735903',
    ],
    [
      '11555212214346132926966321609673228184079851030522218543981385635403167028692',
      '20896918157639814425520058178561910811657326967880217845710779511927814874973',
      '4650158165912007049140499755153804318686705949436165235742106170124284287326',
    ],
    [
      '13880660273492757167295696447853232191657893303250187467329180558670697369810',
      '8043529172463774320604378774840863923445982272478964686447801046272917236836',
      '2134399296482715903442913099374581981696436050603410080564843555725771329441',
    ],
    [
      '27320952903412641133501507962185246982787769547770982814240701526492601978122',
      '23417491374379751329394424924400186404791519133465537872457405970098902747611',
      '17612427354278346772575179176139417348059847375297761006336024476146551185903',
    ],
    [
      '10710998507064742997612080847223278109404482930427999113323732519626499166548',
      '14958094513415797513745395709487730603918953350067504982704138489305723550923',
      '24096319595904213497633343966229498735553590589105811393277073274927955202995',
    ],
    [
      '17983724131200292654039765185049138356840415443160477259330748730019147254309',
      '17598096800487588874709548646068838880468456205252324677357706597166777506441',
      '27420647821110229619898200875848631488422182349567475956209153112306555222281',
    ],
    [
      '448538544835457571662601142415301047108854812427100562339376187510452313026',
      '23494184556634922103535803143214434479598067155171780264810485708203176455201',
      '22626342941879801989161990529511235538216563009907378573817996229389756621777',
    ],
    [
      '26128268137723417163973860961686381960826033145738852158792607959175787222856',
      '20225791828042873305317281581105429726352058325970107209484198122707862156597',
      '7538871133759632802857159609785118198934349221046986784429069814655215585732',
    ],
    [
      '26184554861259642274153262777073624024579929401668865520166966302070394487366',
      '28755259264665180745537307265993667261709206143628938749669440804401623257679',
      '11896066093033549470312328497237649508068258723531931099214795928200015717321',
    ],
    [
      '21657721599978732693249012287058163532690942515202465984736373311077240614059',
      '9214914097169852704753116653702415951907628005986883140609006971322091003693',
      '18710111680849814325169297240208687402588261569152088592693815711857504371037',
    ],
    [
      '6813635166770764528979084175325709935892248249948967889926276426090222296643',
      '20546585456429436268067726231902751119458200511988152296570567167520382569278',
      '20087466019194902429054761607398988292568594301671509779549344754172952693871',
    ],
    [
      '28185105286740691904534067831357491310995891986363455251895371651360605333143',
      '10108348212894231193041286244259038275269464277821588425688314560368589986063',
      '11433633215392393209829215018579238412423821563056156785641278458497271271546',
    ],
    [
      '27870881917195016999862550657996865268956893566432995492427618003637597051321',
      '102309803677783876701097881491240456320211833502658383473112057006867019389',
      '22844040227595875612525628393174357057929113317578127744718774517498324646590',
    ],
    [
      '18364790233947478619325319418813215212267974311771564959136180502266118026133',
      '2480624341921718230432383518425561514824501138863702825916674641657321180841',
      '16778939567530361665956758171503829349658551798564323167725356065198936433124',
    ],
    [
      '11947564511486966895926950599696532964589539443187518177489990556481125699966',
      '3133187646540385483015602955087323554103587039123577645562801570574691666057',
      '27704797101265438206569218421707753788081674727344603874614391656565567951541',
    ],
    [
      '13001484695584753475562184349533365512515447041450030471627087395341039487710',
      '477322000667279478600757543806155989948171541982639893984064422067850617496',
      '13913755821658634147813329813115566967428755223601185963529801459396673113438',
    ],
    [
      '16621869429023470107454028095846067937827722393398508604914831452950874033411',
      '21755744236927410239079501831014076529931327263341620300431356747367343619046',
      '26538666591151124505694487799121414506088199961481579132019627484065014831180',
    ],
    [
      '3066480818457008068617042549071052338581291837882909165666223566402713429090',
      '16182268213934119294035309949459684472027705439038023775276926916166831108357',
      '28907604876608422892474268478706783033050951245339691569015166507728369585190',
    ],
    [
      '27973960109508292680965426133498827831691369851701664449575719912259359998113',
      '1456924360278399121996742356757866616312146358469991014696110099534285524446',
      '8234248752911525485438611255163504976087091103090603316695312869292347668495',
    ],
    [
      '8716078950082339630026654067608811496722305720644485560320987802533380421009',
      '19016744645809919602099479306503354923553336014593353020688463619133130053825',
      '24379650661051444982012238084495990858827340608012118841005379796362233056432',
    ],
    [
      '2245379544097631382062919677963998259142792890502492881341386639439507471783',
      '28788137434161061988371619554419440748189388934884757179010092973102292086583',
      '7187000185648741287953633167647835668543536354944774631102766873251849991238',
    ],
    [
      '18319349500538500800225762827448369057030532278398270164660609327776487168142',
      '2622932985948021877314529887962683530522545893985767148345336304947201715671',
      '13805188629797792210337544360632964855143280581052079479249966961215582531026',
    ],
    [
      '27457600993464082637917106210690168172469473943609357897393615707457194410878',
      '15448646156961779103834447043970817898237835202826003934642165760908058355399',
      '9396792545729486882231669677795667529746274932273033601723318032992363022062',
    ],
    [
      '9927877141952679457141759789181418464292082444806533413864151258248124544859',
      '23827901395971835838179844085051957393677906360196119690926757794561937573142',
      '3273544693673216914876067527455588276979859627093391584406340272737391174619',
    ],
    [
      '19571510438350300564152393820251652609646082150148656806391655428002614034315',
      '4458840243585913642400750597703353770666314833058197517675446022682775625834',
      '6452218213610300363069953741424106105609715382419342511693148495219793324457',
    ],
    [
      '14558167930891460678441266912176752652821641543245953113671886345167213541771',
      '10650967986920075561478528461783351160938460620955779955379459848889204404950',
      '19990009778942542934049216419052172134625404062770188357110708518621145688588',
    ],
    [
      '26855242974447190235826233682457047761532515293146087151296725996543442567035',
      '22785340043356532865086769889360674409753343398766563441587096485751538658065',
      '28603049427449348335651629195385434188071937908693764500052489540779792538285',
    ],
    [
      '20545812864989828913452616721240947168977365844984763819184465128164378967167',
      '23234068381345797209897730226956922073109641728569353961504167817770340037954',
      '26031714567641615877877111172701145299483019910006153132858512509897185854695',
    ],
    [
      '9512221744061419790435674197238913998387834650389922233458121639503195504983',
      '12587458000103271975978240683793268604398305885278203470492658961734100340536',
      '9670291694005369437277651504604785512303147991710650505302465204429311229197',
    ],
    [
      '26995526763045548800439747262386290359229145489609341602564040676717570935439',
      '23742712112104280264401317024221734961713400615669958343926511931219510484675',
      '27931469778579449247589315744656633392873808631802461175539563849884447358271',
    ],
    [
      '20669006894143187877081688942720159738269397552445286314270368345994751825389',
      '26891772301075275370472640177651637211280740381619976926886106618375467277414',
      '28387986011980449959047232529988203397251084614417760995257355718700961696092',
    ],
    [
      '6579105010484741592730389416372694666279917604793318157514380025250233913402',
      '11007035767869292700964744408562802781669930023548892567535397874932420229930',
      '981148366863906885900456473323410468923514528856216824044152942069412627408',
    ],
    [
      '22213671088722307302576907504985884923571642958053627659840326928319445671280',
      '1318836216310789598614608105109389429335273432455224127576823891011367206122',
      '25586582796990779718352441955439394949194222626688223867952982491529809559257',
    ],
    [
      '4923739488579452777913681531125585976446366144127161879759262506690369040090',
      '23505612338866210737103599484620591026802005128655081877133994175016351514827',
      '323887003859465324514901860965142186539600668250760639664361851354147799637',
    ],
    [
      '10198923064967306784017949469108033682156920551672348936591491217255268794658',
      '9593680688139131432883442351722730169325112619984238956948153423155998917175',
      '27027988263960602112273050725720071355535922812577299127302015348825197871870',
    ],
    [
      '14419883951157390867695097127684346981136020111885301573583640959136319507752',
      '5104414988075833278683649298543440897371415916271358703850262680431809374355',
      '24739655595299332818980677669648719986462429574612913501586844601377825836782',
    ],
    [
      '28522818684103966731129743408029731246564480741348128436668680764518115102581',
      '21520350704208288978690888796633940487888044365108767319141211249242880355961',
      '17391005598311948834360476853940353239444383292422171321575043660157438608537',
    ],
    [
      '15367833944125677011173327826570204350687925236257190051755087781855930646142',
      '21715073802090413714601069529558707101797361591183718695054701329871284436172',
      '8994093285353831008525761670339342200997965950202092028313103110478252647618',
    ],
    [
      '8370824693889782161629525898408725452177580012023459750897244954935682978671',
      '16123253540853556024347150096993154278773652905830608614979368087152152043083',
      '3535380953353495025888433493640531836449699255364366295870140701379497967423',
    ],
    [
      '6954518484798178646508803478426114267143074508396663899281411171704702743829',
      '28903134801897070276701950388422104654018369750191967384271618837091859516942',
      '20872505363530172448468374920196608937030884647150175861507911076568784054834',
    ],
    [
      '6902861581703501105786795670676641959401710346423594578401934671029571262513',
      '10124161387604183369443890585742198433184078889862870469507328332805848271064',
      '10488004060799269337071647841224034919633445750252076195310163972966405029030',
    ],
    [
      '507704911991278613147490289466075160618843900088471236546244459176211783848',
      '7252739745607302667257774481690407709040936359589867974787811552896597703097',
      '23278073497974004442836030100920157527910770509761505828038443336325476654930',
    ],
    [
      '22766285055433137793164317120096790621982728188995759745859222009100808389090',
      '23129058299483468195787339200845749049960038336751758017949899311636830205152',
      '16665333681978951552434356320651834889869437822496200946959897681307959400425',
    ],
    [
      '12145699202182574939376505075528461451757079041659894988784442097333218352048',
      '26340666275844437932755852805027863696219004039301187587209926587657008948704',
      '19208771804191839410002226941825269105677187954811130189835856228258013753206',
    ],
    [
      '21957102494792377508237608216278079874536155315851198461024084071231867104453',
      '6933367436450995525851693784691226222726503560893470094614235356287049091852',
      '15707767379191450768747057313641112321773921923533732633534831270357733757271',
    ],
    [
      '27661963645951389261638591385668507557739541354225916772550248746235106571003',
      '19699458096897937575096494582288688995241392471402204995195057374756282223421',
      '902873385171181344315871113842580653512118892800584003934454469411716098791',
    ],
    [
      '17184835876565576154014372215369798779520343573944211203710896053325717110660',
      '664657295519303589036289440053175741110032988007278988577620229144220576240',
      '10803972669668998371638869508774217165881281885838503958226056357738500321396',
    ],
    [
      '2329846733754251453632375727999372856194157027336139087170310553870624325301',
      '14139944357035048486675740400655356660678187875721949218090128899571575479791',
      '18368148273419807418427674359327442879484531833435081951870369910704734685351',
    ],
    [
      '10480273665080572189328459165704340191901489646067580012574464138528963201459',
      '21773636700078124500346009061678153597323236568110076029811348966753228682835',
      '18184268307211429260956076021417309535471438696101133218049142374847151474905',
    ],
    [
      '25957533025669311312382992376854735734491934602484112256289764602447226406852',
      '22223261506176684934865714490719116745135417403915426392159449667435294570739',
      '22937309162832499167063076416585504361695925730111272512450449042837586253575',
    ],
    [
      '16956181785481598286719868503945127919581091625126206673934113115358441284347',
      '8497782777197814773596870810881707148695901557289856910220737358078100998191',
      '21135503731586600979470064722475007625236017670426339278983640892218291297054',
    ],
    [
      '17809297343844488723046665739910571149089769215421130894378638450427880983923',
      '72435395972188389387093550708873189001876361107443937983754878061522372356',
      '7511239878692099209014947248389283109997289411550315391143819429585903287870',
    ],
  ],
  fullRounds: 63,
  partialRounds: 0,
  hasInitialRoundConstant: true,
  stateSize: 3,
  rate: 2,
  power: 5,
};
let mocks = {
  dummyVerificationKeyHash:
    '3392518251768960475377392625298437850623664973002200885669375116181514017494',
};
